/**
 * 内容打印实体
 * zxw
 * 创建时间：2024-04-02
 * 修改时间：2025-12-04
 * 修改内容：将ReactMarkdown更改未XMarkdown
 */

import { useState, useEffect } from 'react';
import {
    Modal,
    Button,
    ConfigProvider,
    Typography,
} from 'antd';
import { Bubble } from '@ant-design/x';
import { locale, Html2pdf, uuid } from '../../incs/FunHelper';

import { XMarkdown } from '@ant-design/x-markdown';
import '@ant-design/x-markdown/themes/light.css';
import HighlightCode from '@ant-design/x-markdown/plugins/HighlightCode';
import Latex from '@ant-design/x-markdown/plugins/Latex';   // 公式
import Mermaid from '@ant-design/x-markdown/plugins/Mermaid'; // 图表

// 思维链
import XinYuanThink from './XinYuanThink';

// 图表
import ChartPiePercent from '../templates/ChartPiePercent'; // 分类百分比（饼图）
import ChartLineUTACD from '../templates/ChartLineUTACD'; // 每日用户活跃统计
import ChartLineUTECY from '../templates/ChartLineUTECY'; // 年度入职人数趋势
import OrgStructureGraph from '../templates/OrgStructureGraph'; // 组织架构图

import ChartLineDateCount from '../templates/ChartLineDateCount'; // 日期数量走势组件（曲线图）
import ChartIntervalTypeCount from '../templates/ChartIntervalTypeCount'; // 类型数量分布组件（柱状图）

import ChartILYearAmount from '../templates/ChartILYearAmount';   // 年度金额趋势统计（柱状和曲线混合图）
import ChartIntervalMonthIOAmount from '../templates/ChartIntervalMonthIOAmount'; // 月份收支统计（柱状图）

// 代码高亮
const Code = props => {
    var _a;
    const { className, children } = props;
    const lang =
        ((_a =
            className === null || className === void 0 ? void 0 : className.match(/language-(\w+)/)) ===
            null || _a === void 0
            ? void 0
            : _a[1]) || '';
    if (typeof children !== 'string') return null;
    if (lang === 'mermaid') return <Mermaid
        code={children}
    />;
    return <HighlightCode
        lang={lang}
    >
        {children}
    </HighlightCode>;
};

const AssistantBoxView = (props) => {
    const [open, setOpen] = useState(false);
    const [format, setFormat] = useState('PDF');
    const cancel = () => { setOpen(false); };


    useEffect(() => {
        setOpen(props.open);
    }, [props]);

    const printer = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head>');
        printWindow.document.write('<link rel="stylesheet" href="https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/css/github-markdown.css"></link>');
        printWindow.document.write('<link rel="stylesheet" href="https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/css/katex.min.css"></link>');
        printWindow.document.write('<title>' + props.title + '</title>');
        printWindow.document.write('</head><body>');
        printWindow.document.write('<div style="width:820px;margin:0 auto;">');
        printWindow.document.write(document.getElementById('print-view-id').innerHTML);
        printWindow.document.write('</div>');
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };
    const download = () => {
        pdf();
    };

    const pdf = () => { Html2pdf('print-view-id', uuid); }


    return (
        <ConfigProvider
            locale={locale}
            theme={{
                token: {
                    colorPrimary: global.THEMECOLOR,
                },
            }}
        >
            <Modal
                width={800}
                style={{ top: 0 }}
                maskClosable={true}
                closable={false}
                open={open}
                keyboard={true}
                onCancel={cancel}
                afterClose={() => {
                    // 指令输入框获取焦点
                    document.getElementById('chat-question-id') && document.getElementById('chat-question-id').focus();
                    props.senderRef && props.senderRef.current.focus({ cursor: 'end', });
                }}
                footer={[
                    <Button key='back' onClick={cancel}>取消</Button>,
                    // <Button key='printer' type='primary' onClick={printer}>打印</Button>,
                    <Button key='link' type='primary' onClick={download}>下载</Button>,
                ]}
            >
                <div id='print-view-id'>
                    <div style={{ padding: '5px 15px' }}>
                        <div style={{ margin: '10px 15px' }}>
                            <div style={{ display: 'inline-block', width: '50%', textAlign: 'left' }}><img crossOrigin='anonymous' src='https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/images/logos/logo-head.png' height='45px' alt={props.preGroup} /></div>
                            {
                                props.preGroup === 'xzt' ? <div style={{ display: 'inline-block', width: '50%', textAlign: 'right' }}><img crossOrigin='anonymous' src='https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/images/logos/page-header-right.png' height='35px' alt='新致腾' /></div> : ''
                            }
                        </div>
                        <div id='print-view-mk-id'>
                            <Bubble
                                key={1}
                                styles={{
                                    content: {
                                        background: '#fff',
                                        // border: '1px solid red',
                                    }
                                }}
                                variant='filled'
                                placement={'start'}
                                content={props.content}
                                contentRender={(content) => {
                                    const newContent = content.replace('/\n\n/g', '<br/><br/>');
                                    return <Typography.Text>
                                        <XMarkdown
                                            content={newContent}
                                            className='x-markdown-light'
                                            style={{
                                                maxWidth: 690,
                                                wordWrap: 'break-word',
                                                overflowX: 'hidden',
                                                overflowWrap: 'break-word',
                                            }}
                                            components={{
                                                code: Code,
                                                'think': XinYuanThink,
                                                'chart-pie-percent': ChartPiePercent,
                                                'chart-line-utacd': ChartLineUTACD,
                                                'chart-line-utecy': ChartLineUTECY,
                                                'org-structure-graph': OrgStructureGraph,
                                                'chart-line-date-count': ChartLineDateCount,
                                                'chart-interval-type-count': ChartIntervalTypeCount,
                                                'chart-il-year-amount': ChartILYearAmount,
                                                'chart-interval-month-io-amount': ChartIntervalMonthIOAmount,
                                            }}
                                            config={{ extensions: Latex() }}
                                            paragraphTag='div'
                                        />
                                    </Typography.Text>
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Modal>
        </ConfigProvider>
    );
};

export default AssistantBoxView;